// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__8TO3N","content":"RecentSearches_content__4ZQnB"};